import type {
  GetScheduleTerms,
  PostScheduleTerm,
  ScheduleTerm,
} from '@entities/schedules/term/types.ts';
import { createApi } from '@reduxjs/toolkit/query/react';
import { getRtkConfig } from '@shared/config/index';

const scheduleTermApi = createApi({
  reducerPath: 'scheduleTermQueries',
  baseQuery: getRtkConfig('/api/v1/'),
  tagTypes: ['scheduleTerms'],
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  endpoints: (build) => ({
    // getScheduleTerms: build.query<GetScheduleTerms, { page: number } | undefined>({
    //   query: (params) => ({
    //     url: `schedules/terms/`,
    //     params,
    //   }),
    //   providesTags: ['scheduleTerms'],
    //   serializeQueryArgs: ({ endpointName }) => {
    //     return endpointName;
    //   },
    //
    //   merge: (currentCache, newItems, otherArgs) => {
    //     // Если страница равна единице или в новых есть с таким же айди, то обновить весь список
    //     if (
    //       otherArgs?.arg?.page === 1 ||
    //       newItems.results.some((с) => с.id === currentCache.results[0].id)
    //     ) {
    //       return newItems;
    //     } else {
    //       currentCache.next = newItems.next;
    //       currentCache.results.push(...newItems.results);
    //     }
    //   },
    //
    //   forceRefetch({ currentArg, previousArg }) {
    //     return currentArg !== previousArg;
    //   },
    // }),
    getScheduleTerms: build.query<GetScheduleTerms, undefined>({
      query: (params) => ({
        url: `schedules/terms/`,
        params,
      }),
      providesTags: ['scheduleTerms'],
    }),

    createScheduleTerm: build.mutation<Response, Partial<PostScheduleTerm>>({
      // createScheduleTerm: build.mutation<Response, FormData>({
      query: (data) => {
        return {
          url: 'schedules/terms/',
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['scheduleTerms'],
    }),

    getScheduleTerm: build.query<ScheduleTerm, { termId?: string }>({
      query: (params) => ({
        // params,
        url: `schedules/terms/${params.termId}`,
        method: 'GET',
      }),
      providesTags: ['scheduleTerms'],
    }),

    updateScheduleTerm: build.mutation<Response, Partial<PostScheduleTerm>>({
      query: ({ id, ...data }) => ({
        url: `schedules/terms/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['scheduleTerms'],
    }),

    deleteScheduleTerm: build.mutation<Response, { id: string }>({
      query: ({ id }) => ({
        url: `schedules/terms/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['scheduleTerms'],
    }),
  }),
});

export const {
  useGetScheduleTermsQuery,
  useGetScheduleTermQuery,
  useCreateScheduleTermMutation,
  useUpdateScheduleTermMutation,
  useDeleteScheduleTermMutation,
} = scheduleTermApi;

export const scheduleTermApiReducerPath = scheduleTermApi.reducerPath;

export const scheduleTermQueriesReducer = scheduleTermApi.reducer;

export const scheduleTermMiddleware = scheduleTermApi.middleware;
